import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AreYouSureGuard } from '@app/core/are-you-sure-guard/are-you-sure.guard';
import { NotExpiredGuard } from '@app/modules/settings/guards/not-expired.guard';
import { PlanSelectionGuard } from '@app/modules/settings/guards/plan-selection.guard';
import { BrandEditComponent } from '@app/modules/settings/pages/brand-edit/brand-edit.component';
import { BrandNewComponent } from '@app/modules/settings/pages/brand-new/brand-new.component';
import { ManageDeviceAddonComponent } from '@app/modules/settings/pages/manage-device-addon/manage-device-addon.component';
import { ManageSubscriptionWizardComponent } from '@app/modules/settings/pages/manage-subscription-wizard/manage-subscription-wizard.component';
import { SettingsTaxesComponent } from '@app/modules/settings/pages/settings-taxes/settings-taxes.component';
import { YourPlanComponent } from '@app/modules/settings/pages/your-plan/your-plan.component';
import { FullScreenModalComponent } from '@app/shared/layouts/full-screen-modal/full-screen-modal.component';
import { SubscriptionDeniedComponent } from './components/subscription-denied/subscription-denied.component';
import { ActivePropertiesComponent } from './pages/active-properties/active-properties.component';
import { BillingDetailsComponent } from './pages/billing-details/billing-details.component';
import { BillingUnavailableComponent } from './pages/billing-unavailable/billing-unavailable.component';
import { GeneralComponent } from './pages/general/general.component';
import { GxComponent } from './pages/gx/gx.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { PaymentMethodsComponent } from './pages/payment-methods/payment-methods.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { SecurityComponent } from './pages/security/security.component';
import { SettingsOperationsComponent } from './pages/settings-operations/settings-operations.component';
import { SettingsPropertiesComponent } from './pages/settings-properties/settings-properties.component';
import { SettingsSyncComponent } from './pages/settings-sync/settings-sync.component';
import { ListTaxesComponent } from './pages/settings-taxes/list-taxes/list-taxes.component';
import { SubscribeComponent } from './pages/subscribe/subscribe.component';
import { SubscriptionExpiredComponent } from './pages/subscription-expired/subscription-expired.component';
import { SupportTiersPageComponent } from './pages/support-tiers-page/support-tiers-page.component';
import { UserManagementInviteComponent } from './pages/user-management-invite/user-management-invite.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'profile',

    pathMatch: 'full',
  },
  {
    path: 'profile',
    component: ProfileComponent,
    data: {
      title: 'Personal info',
    },
  },
  {
    path: 'security',
    component: SecurityComponent,
    data: {
      title: 'Security',
    },
  },
  {
    path: 'billing-details',
    component: BillingDetailsComponent,
    data: {
      title: 'Billing details',
    },
  },
  {
    path: 'invoices',
    component: InvoicesComponent,
    data: {
      title: 'Invoices',
    },
  },
  {
    path: 'user-management',
    component: UserManagementComponent,
    data: {
      title: 'User Management',
    },
  },
  {
    path: 'user-management/invite',
    component: UserManagementInviteComponent,
    data: {
      title: 'Invite a new user',
    },
  },
  {
    path: 'user-management/user/:userId',
    component: UserManagementInviteComponent,
    data: {
      title: 'Edit user',
    },
  },
  {
    path: 'general',
    component: GeneralComponent,
    data: {
      title: 'General',
    },
  },
  {
    path: 'gx',
    component: GxComponent,
    data: {
      title: 'Guest Experience',
    },
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    data: {
      title: 'Notifications',
    },
  },
  {
    path: 'operations',
    component: SettingsOperationsComponent,
    data: {
      title: 'Operations',
    },
  },
  {
    path: 'properties',
    component: SettingsPropertiesComponent,
    data: {
      title: 'Properties',
    },
  },
  {
    path: 'sync',
    component: SettingsSyncComponent,
    data: {
      title: 'Sync settings',
    },
  },
  {
    path: 'your-plan',
    component: YourPlanComponent,
    data: {
      title: 'Your Plan',
    },
  },

  {
    path: 'manage-subscription',
    component: FullScreenModalComponent,
    data: {
      width: '920px',
      title: 'Manage Subscription',
      closeLink: '/settings/your-plan',
    },
    canActivate: [PlanSelectionGuard],
    children: [
      {
        path: '',
        component: ManageSubscriptionWizardComponent,
        canDeactivate: [AreYouSureGuard],
        data: {
          title: 'Manage Subscription',
        },
      },
    ],
  },
  {
    path: 'manage-device-addon',
    component: FullScreenModalComponent,
    data: {
      width: '920px',
      title: 'Manage Smart Devices',
    },

    children: [
      {
        path: '',
        component: ManageDeviceAddonComponent,
        data: {
          title: 'Manage Smart Devices',
        },
      },
    ],
  },
  // For non-primary users, we redirect them here instead when the subscription is expired.
  {
    path: 'subscription/expired',
    component: SubscriptionExpiredComponent,
    data: {
      title: 'Subscription | Denied',
    },
  },
  {
    path: 'support-tiers',
    component: SupportTiersPageComponent,
    data: {
      title: 'Support Tiers',
    },
  },
  {
    path: 'support-tiers/success',
    component: SupportTiersPageComponent,
    data: {
      title: 'Support Tiers',
    },
  },
  {
    path: 'active-properties',
    component: ActivePropertiesComponent,
    data: {
      title: 'Active Properties',
    },
    canActivate: [NotExpiredGuard],
  },

  {
    path: 'subscription',
    redirectTo: 'your-plan',
    pathMatch: 'full',
  },
  {
    path: 'payment-methods',
    component: PaymentMethodsComponent,
    data: {
      title: 'Payment Methods',
    },
  },
  {
    path: 'subscribe',
    component: SubscribeComponent,
    data: {
      title: 'Subscribe',
    },
  },
  // iOS app users are not allowed to manage their subscription
  {
    path: 'subscription/denied',
    component: SubscriptionDeniedComponent,
    data: {
      title: 'Subscription',
    },
  },
  {
    path: 'subscription/unavailable',
    component: BillingUnavailableComponent,
    data: {
      title: 'Billing unavailable',
    },
  },
  {
    path: 'taxes',
    component: ListTaxesComponent,
    data: {
      title: 'Taxes',
    },
  },
  {
    path: 'taxes/:path',
    component: FullScreenModalComponent,
    data: {
      closeLink: '/settings/taxes',
    },
    children: [
      {
        path: '',
        component: SettingsTaxesComponent,
        data: {
          title: 'Taxes',
        },
      },
    ],
  },
  {
    path: 'brands',
    component: BrandEditComponent,
    data: {
      title: 'Your Brand',
    },
  },
  {
    path: 'brands/new',
    component: BrandNewComponent,
    data: {
      title: 'Your Brand',
    },
  },
  {
    path: 'domains',
    loadChildren: () => import('@app/modules/domains/domains.module').then((m) => m.DomainsModule),
  },
  // Start connected accounts redirects to /acccounts
  {
    path: 'accounts/new/vrbo',
    redirectTo: '/accounts/new/vrbo',
  },
  {
    path: 'accounts/new/airbnb',
    redirectTo: '/accounts/new/airbnb',
  },
  {
    path: 'accounts/new/complete',
    redirectTo: '/accounts/new/complete',
  },
  {
    path: 'accounts/update/vrbo/:channel_id/:username',
    redirectTo: '/accounts/update/vrbo/:channel_id/:username',
  },
  {
    path: 'accounts/update/airbnb/:channel_id/:username',
    redirectTo: '/accounts/update/airbnb/:channel_id/:username',
  },
  {
    path: 'accounts/verify/vrbo/:channel_id/:username/:verify_id',
    redirectTo: '/accounts/verify/vrbo/:channel_id/:username/:verify_id',
  },
  {
    path: 'accounts/verify/airbnb/:channel_id/:username/:verify_id',
    redirectTo: '/accounts/verify/airbnb/:channel_id/:username/:verify_id',
  },
  {
    path: 'accounts/listings/:platform/:channel_id',
    redirectTo: '/accounts/listings/:platform/:channel_id',
  },
  {
    path: 'accounts',
    redirectTo: '/accounts',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
